<template>
  <div class="homepage-main">
    <span class="homepage-title row">Actueel</span>

    <div class="row justify-between">
      <SchemesList
        :schemesProp="newestSchemes.results"
        :title="'Nieuwste regelingen'"
      />
      <SchemesList
        :schemesProp="deadlineSchemes.results"
        :title="'Komende deadlines'"
      />
    </div>
    <!--   <div class="row justify-between">
      <SignificantChangesList
        :schemesProp="significantChangesShemes.items"
        :title="'Gewijzigde regelingen'"
      />

      <NewsList :newsProp="latestNews.results" :title="'Laatste nieuws'" />
    </div> -->
    <div class="row">
      <NewsList :newsProp="latestNews.results" :title="'Laatste nieuws'" />
    </div>
  </div>
</template>

<script>
import SchemesList from '../components/homepage-components/SchemesList.vue';
import { onMounted, computed, ref } from 'vue';
import SchemesUtils from '../utils/schemes';
import NewsUtils from '../utils/news';
import store from '../store/index';
import NewsList from '../components/homepage-components/NewsList.vue';
import UserService from '../services/userprofile.service';
/* import SignificantChangesList from '../components/homepage-components/SignificantChangesList.vue';
 */ export default {
  name: 'HomePage',

  components: {
    SchemesList,
    NewsList,
    /*     SignificantChangesList,
     */
  },
  setup() {
    const newestSchemes = computed({
      get: () => store.state.grantItems.newestGrants,
    });

    const latestNews = computed({
      get: () => store.state.news.latestNews,
    });

    const deadlineSchemes = computed({
      get: () => store.state.grantItems.deadlineGrants,
    });

    const significantChangesShemes = computed({
      get: () => store.state.grantItems.significantChangesGrants,
    });

    const favoriteAudience = computed({
      get: () => store.state.user.favoriteAudiencesIdsArray,
    });
    const favoritePurposes = computed({
      get: () => store.state.user.favoritePurposesIdsArray,
    });
    const favoriteLocations = computed({
      get: () => store.state.user.selectedFavoriteLocations,
    });

    onMounted(async () => {
      await UserService.getProfileConfiguration();
      await UserService.getFavoriteAudienceTags();
      await UserService.getFavoritePurposesTags();
      await UserService.getFavoriteLocationsTags();

      var locationsStr = '';
      for (let i = 0; i < favoriteLocations.value.length; i++) {
        locationsStr += favoriteLocations.value[i].id + ',';
      }
      locationsStr = locationsStr.substring(0, locationsStr.length - 1);

      checkForTagsUpdate();
      if (!hasProfileTags.value) {
        await SchemesUtils.searchNewestSchemes(0, 20);
        await SchemesUtils.searchDeadlineSchemes(0, 20);
        await NewsUtils.searchLatestnews(0, 20);
        await SchemesUtils.searchSignificantSchemes(0, 20);
      } else {
        await SchemesUtils.searchNewestSchemesWithTags(
          0,
          20,
          favoriteAudience.value,
          favoritePurposes.value,
          locationsStr
        );

        await SchemesUtils.searchDeadlineSchemesWithTags(
          0,
          20,
          favoriteAudience.value,
          favoritePurposes.value,
          locationsStr
        );
        await NewsUtils.searchLatestnewsWithTags(
          0,
          20,
          favoriteAudience.value,
          favoritePurposes.value,
          locationsStr
        );
        await SchemesUtils.searchSignificantSchemes(0, 20);
      }
    });

    const hasProfileTags = ref(false);

    const checkForTagsUpdate = () => {
      if (
        favoriteAudience.value.length > 0 ||
        favoritePurposes.value.length > 0 ||
        favoriteLocations.value.length > 0
      ) {
        hasProfileTags.value = true;
      }
    };

    return {
      newestSchemes,
      latestNews,
      deadlineSchemes,
      favoriteAudience,
      favoritePurposes,
      favoriteLocations,
      hasProfileTags,
      significantChangesShemes,
    };
  },
};
</script>
